<template>
  <div style="width: 100%; background: #fff">
    <div class="top">
      <!--头部-->
      <v-head></v-head>
      <!--logo+搜索-->
      <div class="search">
        <div class="logo" @click="$router.push('/index')">
          <img src="/static/image/newLogo.png" />
          <div class="lines"></div>
          <div class="logo-des">
            <p>消费帮促</p>
            <p>采购平台</p>
          </div>
        </div>
        <span class="login-tips">
          已有账号，请<span
            style="color: #f89a00; cursor: pointer"
            @click="$router.push('/login')"
            >登录</span
          >
        </span>
      </div>
    </div>
    <div class="mainBox">
      <div class="mainBox-nav">
        <div
          v-for="(item, index) in navList"
          :class="[
            'mainBox-navList',
            navIndex >= index ? ' active' : '',
            navIndex >= index + 1 ? 'activeF' : '',
          ]"
          :key="index"
          @click="changeNav(index)"
        >
          <div class="mainBox-navText">{{ item }}</div>
        </div>
      </div>

      <div class="mainBox-form" v-if="navIndex == 0">
        <div class="mainBox-label">
          <span class="formLabel">账号：</span>
          <span class="formLabel">单位名称：</span>
          <span class="formLabel">手机号：</span>
          <!-- <span class="formLabel">图片验证码：</span> -->
          <span class="formLabel">短信验证码：</span>
          <span class="formLabel">密码：</span>
          <span class="formLabel">确认密码：</span>
        </div>
        <div class="mainBox-tips">
          <span class="formTips"
            >请输入4-32位字符。只能包括英文字母、数字和下划线，不能为纯数字，不能为纯下划线</span
          >
          <span class="formTips"></span>
          <span class="formTips"
            >请输入11位手机号码（此号码为接收短信号码）</span
          >
          <!-- <span class="formTips">请输入左方算式的计算结果</span> -->
          <span class="formTips"></span>
          <span class="formTips"
            >请输入8~30位密码，密码必须同包含字母和数字</span
          >
          <span class="formTips">请于上方填写的密码保持一致</span>
        </div>

        <div class="mainBox-formList">
          <input class="search-input" type="text" v-model="userName" />
        </div>
        <div class="mainBox-formList">
          <input class="search-input" type="text" v-model="name" />
        </div>
        <div class="mainBox-formList">
          <input class="search-input" type="text" v-model="phone" />
        </div>
        <!-- <div class="mainBox-formList">
          <input
            class="search-input"
            type="text"
            style="width:190px;margin-right:15px"
          /><button class="codeBtn">获取验证码</button>
        </div> -->
        <div class="mainBox-formList">
          <input
            class="search-input"
            type="text"
            style="width: 190px; margin-right: 15px"
            v-model="verificationCode"
          /><button class="codeBtn" @click="sendCode()" :disabled="disable">
            {{ content }}
          </button>
        </div>
        <div class="mainBox-formList">
          <input class="search-input" type="password" v-model="password" />
        </div>
        <div class="mainBox-formList">
          <input class="search-input" type="password" v-model="checkPassword" />
        </div>
        <!-- <div class="mainBox-formType">
          <div class="mainBox-checkbox">
            <input
              type="checkbox"
              name="type"
              id="check1"
              style="margin-right:10px"
              @click="changeCheckbox1"
              :checked="isChecked"
            /><label style="cursor: pointer;" for="check1">我是采购人</label>
          </div>
          <div class="mainBox-checkbox">
            <input
              type="checkbox"
              name="type"
              id="check2"
              style="margin-right:10px"
              :checked="!isChecked"
              @click="changeCheckbox2"
            />
            <label style="cursor: pointer;" for="check2">我是供应商</label>
          </div>
        </div>-->
        <div class="mainBox-formType">
          <input
            type="checkbox"
            style="margin-right: 6px"
            id="check3"
            :checked="isChecked"
            @click="changeCheckbox"
          /><label style="cursor: pointer" for="check3"
            >我已阅读并同意 《注册协议》</label
          >
        </div>
        <button class="mainBox-btn" @click="handleRegister()">注册</button>
      </div>
      <div class="mainBox_material" v-if="navIndex == 1">
        <el-form
          label-position="right"
          label-width="135px"
          :model="perfectData"
          ref="perfectData"
          :rules="rules"
          autoComplete="off"
        >
          <el-form-item
            label="采购人类型："
            prop="purType"
            style="margin-bottom: 11px"
          >
            <el-radio-group v-model="perfectData.purType">
              <el-radio
                :label="index"
                v-for="(item, index) in purTypeList"
                :key="index"
                >{{ item }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <div class="mainBox_materialTip">
            温馨提示：请根据证件选择正确的采购人类型，如：”工会委员会”请选择“团体组织”；“企业”请选择“其他”！
          </div>

          <el-form-item
            :label="
              perfectData.purType == 0
                ? '机关名称：'
                : perfectData.purType == 1
                ? '单位名称：'
                : perfectData.purType == 2
                ? '团体名称：'
                : '公司名称：'
            "
            prop="companyName"
          >
            <el-input
              v-model="perfectData.companyName"
              placeholder="请填写与证书一致的单位名称"
              autoComplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="
              perfectData.purType == 0
                ? '机关简称：'
                : perfectData.purType == 1
                ? '单位简称：'
                : perfectData.purType == 2
                ? '团体简称：'
                : '企业简称：'
            "
            prop="companyAbb"
          >
            <el-input v-model="perfectData.companyAbb"></el-input>
          </el-form-item>
          <el-form-item
            label="法人代表："
            v-if="perfectData.purType == 3"
            prop="legalPerson"
          >
            <el-input v-model="perfectData.legalPerson"></el-input>
          </el-form-item>
          <el-form-item
            label="法人身份证号码："
            v-if="perfectData.purType == 3"
            prop="legalIdNum"
          >
            <el-input v-model="perfectData.legalIdNum"></el-input>
          </el-form-item>
          <el-form-item label="联系人姓名：" prop="userName">
            <el-input v-model="perfectData.userName"></el-input>
          </el-form-item>
          <el-form-item
            label="身份证号码："
            v-if="perfectData.purType != 3"
            prop="legalIdNum"
          >
            <el-input v-model="perfectData.legalIdNum"></el-input>
          </el-form-item>

          <el-form-item label="手机号码：" prop="telephone">
            <el-input v-model="perfectData.telephone"></el-input>
          </el-form-item>
          <el-form-item
            label="统一信用代码："
            v-if="perfectData.purType != 3"
            prop="creditCode"
          >
            <el-input v-model="perfectData.creditCode"></el-input>
          </el-form-item>

          <el-form-item
            :label="perfectData.purType == 3 ? '单位地址：' : '地址：'"
            prop="companyAddr"
          >
            <area-select
              v-model="perfectData.companyAddr"
              :data="$pcaa"
              :level="3"
              style="display: flex; line-height: 18px"
              type="all"
            ></area-select>
          </el-form-item>
          <el-form-item label="详细地址：" prop="companyAddrDetail">
            <el-input v-model="perfectData.companyAddrDetail"></el-input>
          </el-form-item>

          <el-form-item label="邮箱：" prop="email">
            <el-input v-model="perfectData.email"></el-input>
          </el-form-item>
          <el-form-item label="固定电话：" prop="fixedTel">
            <el-input v-model="perfectData.fixedTel"></el-input>
          </el-form-item>

          <el-form-item label="所属预算单位：" prop="belongCompanyName">
            <el-input
              v-model="perfectData.belongCompanyName"
              placeholder="未绑定所属预算单位"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="企业类型："
            v-if="perfectData.purType == 3"
            prop="companyType"
          >
            <el-select v-model="perfectData.companyType">
              <el-option
                v-for="(item, index) in options"
                :key="item"
                :label="item"
                :value="index"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <div class="mainBox_materialTip" style="margin-left: 135px">
            所属预算单位：承担预算单位采购任务的预算单位名称；只有绑定预算所属单位后，您的已完成订单交易金额才能计算到预算单位已完成交易额中。
          </div>
          <!-- logo -->
          <el-form-item
            :label="
              perfectData.purType == 0
                ? '机关logo：'
                : perfectData.purType == 1
                ? '单位logo：'
                : perfectData.purType == 2
                ? '团体logo：'
                : '公司logo：'
            "
            class="uploadItem"
            label-width="236px"
            prop="companyLogo"
          >
            <el-upload
              :action="baseURL + uploadUrl"
              list-type="picture-card"
              :class="{ hideUploadLogo: perfectData.companyLogo }"
              :on-change="
                (file, fileList) => handleChange(file, fileList, 'companyLogo')
              "
              :before-upload="beforeUpload"
              :on-success="
                (response, file, fileList) =>
                  handleSuccess(response, file, fileList, 'companyLogo')
              "
              :on-remove="
                (file, fileList) => handleRemove(file, fileList, 'companyLogo')
              "
              :on-preview="
                (file, fileList) => handlePreview(file, fileList, 'companyLogo')
              "
              accept=".jpg,.jpeg,.png"
              :limit="1"
            >
              <div slot="tip" class="el-upload__tip">
                只能上传jpg/jpeg/png文件，且不超过500kb
              </div>
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="visible.companyLogo">
              <img width="100%" :src="perfectData.companyLogo" alt="" />
            </el-dialog>
          </el-form-item>
          <div class="cardBox" v-if="perfectData.purType == 3">
            <el-form-item
              label="是否统一信用代码："
              style="margin: 20px 25px"
              label-width="149px"
              prop="isCreditCode"
            >
              <el-radio-group v-model="perfectData.isCreditCode">
                <el-radio :label="1">是</el-radio
                ><el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <div class="line"></div>
            <el-form-item
              label="营业执照号："
              prop="busLicenseNo"
              v-if="perfectData.isCreditCode == 0"
            >
              <el-input v-model="perfectData.busLicenseNo"></el-input>
            </el-form-item>
            <el-form-item
              label="组织机构代码："
              prop="orgNo"
              v-if="perfectData.isCreditCode == 0"
            >
              <el-input v-model="perfectData.orgNo"></el-input>
            </el-form-item>
            <el-form-item
              label="税务登记号："
              prop="taxId"
              v-if="perfectData.isCreditCode == 0"
            >
              <el-input v-model="perfectData.taxId"></el-input>
            </el-form-item>
            <el-form-item
              label="统一信用代码："
              prop="creditCode"
              v-if="perfectData.isCreditCode == 1"
            >
              <el-input v-model="perfectData.creditCode"></el-input>
            </el-form-item>
            <!-- 营业执照 -->
            <el-form-item
              label="营业执照："
              class="uploadItem"
              label-width="236px"
              prop="busLicenseImg"
            >
              <el-upload
                :action="baseURL + uploadUrl"
                list-type="picture-card"
                :class="{ hideUploadLogo: perfectData.busLicenseImg }"
                :on-change="
                  (file, fileList) =>
                    handleChange(file, fileList, 'busLicenseImg')
                "
                :before-upload="beforeUpload"
                :on-success="
                  (response, file, fileList) =>
                    handleSuccess(response, file, fileList, 'busLicenseImg')
                "
                :on-remove="
                  (file, fileList) =>
                    handleRemove(file, fileList, 'busLicenseImg')
                "
                :on-preview="
                  (file, fileList) =>
                    handlePreview(file, fileList, 'busLicenseImg')
                "
                accept=".jpg,.jpeg,.png"
                :limit="1"
              >
                <div slot="tip" class="el-upload__tip">
                  只能上传jpg/jpeg/png文件，且不超过500kb
                </div>
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="visible.busLicenseImg">
                <img width="100%" :src="perfectData.busLicenseImg" alt="" />
              </el-dialog>
              <div class="mainBox_uploadTip">
                （上传清晰可读的原件或带公章的复印件）
              </div>
            </el-form-item>
            <!-- 组织机构代码 -->
            <el-form-item
              label="组织机构代码："
              class="uploadItem"
              label-width="236px"
              prop="orgNoImg"
              v-if="perfectData.isCreditCode == 0"
            >
              <el-upload
                :action="baseURL + uploadUrl"
                list-type="picture-card"
                :class="{ hideUploadLogo: perfectData.orgNoImg }"
                :on-change="
                  (file, fileList) => handleChange(file, fileList, 'orgNoImg')
                "
                :before-upload="beforeUpload"
                :on-success="
                  (response, file, fileList) =>
                    handleSuccess(response, file, fileList, 'orgNoImg')
                "
                :on-remove="
                  (file, fileList) => handleRemove(file, fileList, 'orgNoImg')
                "
                :on-preview="
                  (file, fileList) => handlePreview(file, fileList, 'orgNoImg')
                "
                accept=".jpg,.jpeg,.png"
                :limit="1"
              >
                <div slot="tip" class="el-upload__tip">
                  只能上传jpg/jpeg/png文件，且不超过500kb
                </div>
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="visible.orgNoImg">
                <img width="100%" :src="perfectData.orgNoImg" alt="" />
              </el-dialog>
              <div class="mainBox_uploadTip">
                （上传清晰可读的原件或带公章的复印件）
              </div>
            </el-form-item>
            <!-- 组织机构代码证 -->
            <el-form-item
              label="组织机构代码证："
              class="uploadItem"
              label-width="236px"
              prop="orgNoCardImg"
              v-if="perfectData.isCreditCode == 0"
            >
              <el-upload
                :action="baseURL + uploadUrl"
                list-type="picture-card"
                :class="{ hideUploadLogo: perfectData.orgNoCardImg }"
                :on-change="
                  (file, fileList) =>
                    handleChange(file, fileList, 'orgNoCardImg')
                "
                :before-upload="beforeUpload"
                :on-success="
                  (response, file, fileList) =>
                    handleSuccess(response, file, fileList, 'orgNoCardImg')
                "
                :on-remove="
                  (file, fileList) =>
                    handleRemove(file, fileList, 'orgNoCardImg')
                "
                :on-preview="
                  (file, fileList) =>
                    handlePreview(file, fileList, 'orgNoCardImg')
                "
                accept=".jpg,.jpeg,.png"
                :limit="1"
              >
                <div slot="tip" class="el-upload__tip">
                  只能上传jpg/jpeg/png文件，且不超过500kb
                </div>
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="visible.orgNoCardImg">
                <img width="100%" :src="perfectData.orgNoCardImg" alt="" />
              </el-dialog>
              <div class="mainBox_uploadTip">
                （上传清晰可读的原件或带公章的复印件）
              </div>
            </el-form-item>
          </div>
          <!-- 银行开户许可证 -->
          <el-form-item
            label="银行开户许可证："
            class="uploadItem"
            label-width="236px"
            v-if="perfectData.purType == 3"
            prop="bankAccountPermit"
          >
            <el-upload
              :action="baseURL + uploadUrl"
              list-type="picture-card"
              :class="{ hideUploadLogo: perfectData.bankAccountPermit }"
              :on-change="
                (file, fileList) =>
                  handleChange(file, fileList, 'bankAccountPermit')
              "
              :before-upload="beforeUpload"
              :on-success="
                (response, file, fileList) =>
                  handleSuccess(response, file, fileList, 'bankAccountPermit')
              "
              :on-remove="
                (file, fileList) =>
                  handleRemove(file, fileList, 'bankAccountPermit')
              "
              :on-preview="
                (file, fileList) =>
                  handlePreview(file, fileList, 'bankAccountPermit')
              "
              accept=".jpg,.jpeg,.png"
              :limit="1"
            >
              <div slot="tip" class="el-upload__tip">
                只能上传jpg/jpeg/png文件，且不超过500kb
              </div>
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="visible.bankAccountPermit">
              <img width="100%" :src="perfectData.bankAccountPermit" alt="" />
            </el-dialog>
            <div class="mainBox_uploadTip">
              （请上传带有公章的有效许可证或基本存款账户信息）
            </div>
          </el-form-item>
          <!-- 证件信息 -->
          <el-form-item
            label="证件信息："
            label-width="236px"
            v-if="perfectData.purType == 3"
            prop="certType"
          >
            <el-radio-group v-model="perfectData.certType">
              <el-radio :label="0">法人身份证复印件</el-radio
              ><el-radio :label="1">受托人身份证复印件</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 统一信用代码证复印件 -->
          <el-form-item
            label="统一信用代码证复印件："
            class="uploadItem"
            label-width="236px"
            v-if="perfectData.purType != 3"
            prop="creditCodeImg"
          >
            <el-upload
              :action="baseURL + uploadUrl"
              list-type="picture-card"
              :class="{ hideUploadLogo: perfectData.creditCodeImg }"
              :on-change="
                (file, fileList) =>
                  handleChange(file, fileList, 'creditCodeImg')
              "
              :before-upload="beforeUpload"
              :on-success="
                (response, file, fileList) =>
                  handleSuccess(response, file, fileList, 'creditCodeImg')
              "
              :on-remove="
                (file, fileList) =>
                  handleRemove(file, fileList, 'creditCodeImg')
              "
              :on-preview="
                (file, fileList) =>
                  handlePreview(file, fileList, 'creditCodeImg')
              "
              accept=".jpg,.jpeg,.png"
              :limit="1"
            >
              <div slot="tip" class="el-upload__tip">
                只能上传jpg/jpeg/png文件，且不超过500kb
              </div>
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="visible.creditCodeImg">
              <img width="100%" :src="perfectData.creditCodeImg" alt="" />
            </el-dialog>
            <div class="mainBox_uploadTip">
              （请上传在有效期内、清晰可读、完整的证书）
            </div>
          </el-form-item>
          <!-- 法人证书复印件 -->
          <el-form-item
            label="法人证书复印件："
            class="uploadItem"
            label-width="236px"
            v-if="perfectData.purType == 1"
            prop="legalCertImg"
          >
            <el-upload
              :action="baseURL + uploadUrl"
              list-type="picture-card"
              :class="{ hideUploadLogo: perfectData.legalCertImg }"
              :on-change="
                (file, fileList) => handleChange(file, fileList, 'legalCertImg')
              "
              :before-upload="beforeUpload"
              :on-success="
                (response, file, fileList) =>
                  handleSuccess(response, file, fileList, 'legalCertImg')
              "
              :on-remove="
                (file, fileList) =>
                  handleRemove(file, fileList, 'legalCertImg ')
              "
              :on-preview="
                (file, fileList) =>
                  handlePreview(file, fileList, 'legalCertImg ')
              "
              accept=".jpg,.jpeg,.png"
              :limit="1"
            >
              <div slot="tip" class="el-upload__tip">
                只能上传jpg/jpeg/png文件，且不超过500kb
              </div>
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="visible.legalCertImg">
              <img width="100%" :src="perfectData.legalCertImg" alt="" />
            </el-dialog>
            <div class="mainBox_uploadTip">
              （请上传在有效期内、清晰可读、完整且加盖红章的事业单位法人证书复印件）
            </div>
          </el-form-item>
          <!-- 法人身份证复印件（正面）： -->
          <el-form-item
            label="法人身份证复印件（正面）："
            class="uploadItem"
            label-width="236px"
            v-if="perfectData.purType == 2 || perfectData.purType == 3"
            prop="legalIdFront"
          >
            <el-upload
              :action="baseURL + uploadUrl"
              list-type="picture-card"
              :class="{ hideUploadLogo: perfectData.legalIdFront }"
              :on-change="
                (file, fileList) => handleChange(file, fileList, 'legalIdFront')
              "
              :before-upload="beforeUpload"
              :on-success="
                (response, file, fileList) =>
                  handleSuccess(response, file, fileList, 'legalIdFront')
              "
              :on-remove="
                (file, fileList) => handleRemove(file, fileList, 'legalIdFront')
              "
              :on-preview="
                (file, fileList) =>
                  handlePreview(file, fileList, 'legalIdFront')
              "
              accept=".jpg,.jpeg,.png"
              :limit="1"
            >
              <div slot="tip" class="el-upload__tip">
                只能上传jpg/jpeg/png文件，且不超过500kb
              </div>
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="visible.legalIdFront">
              <img width="100%" :src="perfectData.legalIdFront" alt="" />
            </el-dialog>
            <div class="mainBox_uploadTip">
              （请上传有效期内的、清晰可读、完整的法人身份证正面）
            </div>
          </el-form-item>
          <!-- 法人身份证复印件（反面）： -->
          <el-form-item
            label="法人身份证复印件（反面）："
            class="uploadItem"
            label-width="236px"
            v-if="perfectData.purType == 2 || perfectData.purType == 3"
            prop="legalIdBack"
          >
            <el-upload
              :action="baseURL + uploadUrl"
              list-type="picture-card"
              :class="{ hideUploadLogo: perfectData.legalIdBack }"
              :on-change="
                (file, fileList) => handleChange(file, fileList, 'legalIdBack')
              "
              :before-upload="beforeUpload"
              :on-success="
                (response, file, fileList) =>
                  handleSuccess(response, file, fileList, 'legalIdBack')
              "
              :on-remove="
                (file, fileList) => handleRemove(file, fileList, 'legalIdBack')
              "
              :on-preview="
                (file, fileList) => handlePreview(file, fileList, 'legalIdBack')
              "
              accept=".jpg,.jpeg,.png"
              :limit="1"
            >
              <div slot="tip" class="el-upload__tip">
                只能上传jpg/jpeg/png文件，且不超过500kb
              </div>
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="visible.legalIdBack">
              <img width="100%" :src="perfectData.legalIdBack" alt="" />
            </el-dialog>
            <div class="mainBox_uploadTip">
              （请上传有效期内的、清晰可读、完整的法人身份证反面）
            </div>
          </el-form-item>
          <!-- 联系人身份证复印件（正面） -->
          <el-form-item
            label="联系人身份证复印件（正面）："
            class="uploadItem"
            label-width="236px"
            v-if="perfectData.purType != 3"
            prop="contactIdFront"
          >
            <el-upload
              :action="baseURL + uploadUrl"
              list-type="picture-card"
              :class="{ hideUploadLogo: perfectData.contactIdFront }"
              :on-change="
                (file, fileList) =>
                  handleChange(file, fileList, 'contactIdFront')
              "
              :before-upload="beforeUpload"
              :on-success="
                (response, file, fileList) =>
                  handleSuccess(response, file, fileList, 'contactIdFront')
              "
              :on-remove="
                (file, fileList) =>
                  handleRemove(file, fileList, 'contactIdFront')
              "
              :on-preview="
                (file, fileList) =>
                  handlePreview(file, fileList, 'contactIdFront')
              "
              accept=".jpg,.jpeg,.png"
              :limit="1"
            >
              <div slot="tip" class="el-upload__tip">
                只能上传jpg/jpeg/png文件，且不超过500kb
              </div>
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="visible.contactIdFront">
              <img width="100%" :src="perfectData.contactIdFront" alt="" />
            </el-dialog>
            <div class="mainBox_uploadTip">
              （请上传与所填联系人姓名一致的、有效期内的、清晰可读且
              完整的联系人身份证正面）
            </div>
          </el-form-item>
          <!-- 联系人身份证复印件（反面） -->
          <el-form-item
            label="联系人身份证复印件（反面）："
            class="uploadItem"
            label-width="236px"
            v-if="perfectData.purType != 3"
            prop="contactIdBack"
          >
            <el-upload
              :action="baseURL + uploadUrl"
              list-type="picture-card"
              :class="{ hideUploadLogo: perfectData.contactIdBack }"
              :on-change="
                (file, fileList) =>
                  handleChange(file, fileList, 'contactIdBack')
              "
              :before-upload="beforeUpload"
              :on-success="
                (response, file, fileList) =>
                  handleSuccess(response, file, fileList, 'contactIdBack')
              "
              :on-remove="
                (file, fileList) =>
                  handleRemove(file, fileList, 'contactIdBack')
              "
              :on-preview="
                (file, fileList) =>
                  handlePreview(file, fileList, 'contactIdBack')
              "
              accept=".jpg,.jpeg,.png"
              :limit="1"
            >
              <div slot="tip" class="el-upload__tip">
                只能上传jpg/jpeg/png文件，且不超过500kb
              </div>
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="visible.contactIdBack">
              <img width="100%" :src="perfectData.contactIdBack" alt="" />
            </el-dialog>
            <div class="mainBox_uploadTip">
              （请上传与所填联系人姓名一致的、有效期内的、清晰可读且
              完整的联系人身份证反面）
            </div>
          </el-form-item>
        </el-form>
        <el-button
          class="mainBox_materialBtn"
          type="primary"
          @click="submit('perfectData')"
        >
          提交</el-button
        >
      </div>
      <div class="mainBox_examine" v-if="navIndex == 2">
        <img
          src="/static/image/success.png"
          alt=""
          class="mainBox_examineImg"
        />
        <div class="mainBox_examineText">资料提交成功</div>
        <div class="mainBox_examineText">平台审核中，请耐心等待！</div>
        <div class="mainBox_examineTip">
          {{ countdown }}s后自动跳转到<span
            style="color: #f89a00; cursor: pointer"
            @click="$router.push('/personal')"
            >个人中心</span
          >页面
        </div>
      </div>
    </div>
    <el-dialog
      title="提示信息"
      :visible.sync="isWrong"
      width="505px"
      :show-close="false"
    >
      <span>表单数据有误，请检查！</span>
      <span
        slot="footer"
        class="dialog-footer"
        style="display: flex; justify-content: center"
      >
        <el-button
          type="primary"
          @click="isWrong = false"
          style="width: 98px; height: 40px; line-height: 14px; border-radius: 0"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="注册成功"
      :visible.sync="registerSuccess"
      width="495px"
      :show-close="false"
    >
      <div style="display: flex; flex-direction: column; align-items: center">
        <div style="display: flex; align-items: center">
          <img
            src="/static/image/success.png"
            alt=""
            style="width: 25px; height: 25px; margin-right: 15px"
          />
          <span
            style="
              font-size: 16px;
              font-family: Microsoft YaHei, Microsoft YaHei-Regular;
              font-weight: 400;
              color: #333333;
            "
            >恭喜您，注册成功！</span
          >
        </div>
        <span
          style="
            font-size: 12px;
            font-family: Microsoft YaHei, Microsoft YaHei-Regular;
            font-weight: 400;
            color: #777777;
            margin-top: 20px;
          "
          >【为了您更便捷的使用相关功能，您还需要尽快完善信息】</span
        >
      </div>
      <span
        slot="footer"
        class="dialog-footer"
        style="display: flex; justify-content: center"
      >
        <el-button
          @click="$router.push('/index')"
          style="
            width: 98px;
            height: 40px;
            line-height: 14px;
            border-radius: 0;
            margin-right: 30px;
            border: 1px solid #f89a00;
          "
          >返回首页</el-button
        >
        <el-button
          type="primary"
          @click="
            navIndex = 1;
            registerSuccess = false;
            perfectData.telephone = phone;
          "
          style="width: 98px; height: 40px; line-height: 14px; border-radius: 0"
          >完善信息</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import vHead from "../common/header2.vue";
import { doGet, postAction, baseURL } from "../common/HttpHelper.js";
import { httpConfig } from "../common/config.js";
export default {
  data() {
    return {
      checkRegNo: (rule, value, callback) => {
        var city = {
          11: "北京",
          12: "天津",
          13: "河北",
          14: "山西",
          15: "内蒙古",
          21: "辽宁",
          22: "吉林",
          23: "黑龙江 ",
          31: "上海",
          32: "江苏",
          33: "浙江",
          34: "安徽",
          35: "福建",
          36: "江西",
          37: "山东",
          41: "河南",
          42: "湖北 ",
          43: "湖南",
          44: "广东",
          45: "广西",
          46: "海南",
          50: "重庆",
          51: "四川",
          52: "贵州",
          53: "云南",
          54: "西藏 ",
          61: "陕西",
          62: "甘肃",
          63: "青海",
          64: "宁夏",
          65: "新疆",
          71: "台湾",
          81: "香港",
          82: "澳门",
          91: "国外 ",
        };
        var tip = "";
        var pass = true;

        var patt1 = new RegExp(
          "(^[1-9]\\d{5}(18|19|([23]\\d))\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}[0-9Xx]$)|(^[1-9]\\d{5}\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{2}$)"
        );
        if (value == "") {
          pass = true;
        } else if (!patt1.test(value)) {
          callback(new Error("身份证号格式错误"));
          pass = false;
        } else if (!city[value.substr(0, 2)]) {
          callback(new Error("地址编码错误"));
          pass = false;
        } else {
          //18位身份证需要验证最后一位校验位
          if (value.length == 18) {
            value = value.split("");
            //∑(ai×Wi)(mod 11)
            //加权因子
            var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
            //校验位
            var parity = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
            var sum = 0;
            var ai = 0;
            var wi = 0;
            for (var i = 0; i < 17; i++) {
              ai = value[i];
              wi = factor[i];
              sum += ai * wi;
            }
            var last = parity[sum % 11];
            if (parity[sum % 11] != value[17]) {
              callback(new Error("身份证号码错误"));
              pass = false;
            }
          }
        }
        if (pass) {
          callback();
        }
      },
      baseURL,
      uploadUrl: httpConfig.upload.url,
      navList: ["账号注册", "完善资料", "平台审核"],
      navIndex: 0,
      isChecked: true,

      userName: "",
      name: "",
      phone: "",
      verificationCode: "",
      password: "",
      checkPassword: "",

      content: "发送验证码",
      totalTime: 60,
      disable: false,

      purTypeList: ["行政机关", "事业单位", "团体组织", "其他"], //采购人类型列表

      perfectData: {
        purType: 0, //采购人类型
        companyName: undefined, //公司名称
        companyAbb: undefined, //公司简称
        legalPerson: undefined, //法人代表
        legalIdNum: undefined, //法人身份证号码
        userName: undefined, //联系人姓名
        telephone: undefined, //手机号码
        creditCode: undefined, //统一信用代码
        companyAddr: [], //单位地址
        companyAddrCode: "", //单位地址编码
        companyAddrDetail: undefined, //详细地址
        email: undefined, //邮箱
        fixedTel: undefined, //固定电话
        belongCompanyName: undefined, //所属预算单位
        companyType: undefined, //企业类型

        busLicenseNo: undefined, //营业执照号
        orgNo: undefined, //组织机构代码
        taxId: undefined, //税务登记号

        isCreditCode: 0, //是否统一信用代码
        certType: 1, //证件信息

        //图片
        companyLogo: undefined, //企业logo

        busLicenseImg: undefined, //营业执照照片
        orgNoImg: undefined, //组织机构代码照片
        orgNoCardImg: undefined, //组织机构代码证照片

        bankAccountPermit: undefined, //银行开户许可证
        creditCodeImg: undefined, //统一信用代码证复印件
        legalCertImg: undefined, //法人证书复印件
        legalIdFront: undefined, //法人身份证（正面）
        legalIdBack: undefined, //法人身份证（反面）
        contactIdFront: undefined, //联系人身份证（正面）
        contactIdBack: undefined, //联系人身份证（反面）
      },

      visible: {
        companyLogo: false,
        busLicenseImg: false,
        orgNoImg: false,
        orgNoCardImg: false,
        bankAccountPermit: false,
        creditCodeImg: false,
        legalCertImg: false, //法人证书
        legalIdFront: false,
        legalIdBack: false,
        contactIdFront: false, //联系人身份证（正面）
        contactIdBack: false, //联系人身份证（反面）
      },

      options: [
        "中外合资经营企业",
        "私营独资企业",
        "国有企业",
        "其他",
        "私营合伙企业",
        "私营有限责任公司",
        "私营股份有限公司",
        "集体企业",
        "股份合作企业",
        "有限责任公司（国有独资或控股）",
        "其他有限责任公司",
        "股份有限公司",
        "其他内资企业",
        "中外合作经营企业",
        "外商投资股份有限公司",
        "个体经营",
        "三来一补",
        "法人分支机构",
        "一人有限责任公司",
        "有限责任公司",
        "农民专业合作经济组织",
        "酒店",
        "饭店",
        "监狱",
        "医院",
      ],
      registerSuccess: false,
      isWrong: false,
      countdown: 3,
    };
  },
  computed: {
    rules: function () {
      return {
        purType: [
          {
            required: true,
            message: "请选择采购人类型",
            trigger: "blur",
          },
        ],
        companyName: [
          {
            required: true,
            message:
              this.perfectData.purType == 0
                ? "请输入机关名称"
                : this.perfectData.purType == 1
                ? "请输入单位名称"
                : this.perfectData.purType == 2
                ? "请输入团体名称"
                : "请输入公司名称",
            trigger: "blur",
          },
        ],
        companyAbb: [
          {
            required: true,
            message:
              this.perfectData.purType == 0
                ? "请输入机关简称"
                : this.perfectData.purType == 1
                ? "请输入单位简称"
                : this.perfectData.purType == 2
                ? "请输入团体简称"
                : "请输入企业简称",
            trigger: "blur",
          },
        ],
        legalPerson: [
          {
            required: true,
            message: "请输入法人代表",
            trigger: "blur",
          },
        ],
        legalIdNum: [
          {
            required: true,
            message:
              this.perfectData.purType != 3
                ? "请输入身份证号码"
                : "请输入法人身份证号码",
            trigger: "blur",
          },
          { validator: this.checkRegNo, trigger: "blur" },
        ],
        userName: [
          {
            required: true,
            message: "请输入联系人姓名",
            trigger: "blur",
          },
        ],
        telephone: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: "blur",
          },
          {
            pattern:
              /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        creditCode: [
          {
            required: true,
            message: "请输入统一信用代码",
            trigger: "blur",
          },
        ],
        companyAddr: [
          {
            required: true,
            message:
              this.perfectData.purType != 3 ? "请选择地址" : "请选择单位地址",
            trigger: "blur",
          },
        ],
        companyAddrDetail: [
          {
            required: true,
            message: "请输入详细地址",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: "请输入邮箱",
            trigger: "blur",
          },
          {
            pattern: /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/,
            message: "请输入正确的邮箱",
            trigger: "blur",
          },
        ],
        fixedTel: [
          {
            required: true,
            message: "请输入固定电话",
            trigger: "blur",
          },
          {
            pattern: /^(0[0-9]{2,3}\-)([2-9][0-9]{4,7})+(\-[0-9]{1,4})?$/,
            message: "请输入正确的固定电话（例025-********）",
            trigger: "blur",
          },
        ],

        belongCompanyName: [
          {
            required: true,
            message: "请输入所属预算单位",
            trigger: "blur",
          },
        ],
        companyType: [
          {
            required: true,
            message: "请选择企业类型",
            trigger: "blur",
          },
        ],

        busLicenseNo: [
          {
            required: true,
            message: "请输入营业执照号",
            trigger: "blur",
          },
        ],
        orgNo: [
          {
            required: true,
            message: "请输入组织机构代码",
            trigger: "blur",
          },
        ],
        taxId: [
          {
            required: true,
            message: "请输入税务登记号",
            trigger: "blur",
          },
        ],
        isCreditCode: [
          {
            required: true,
            message: "请选择是否统一信用代码",
            trigger: "blur",
          },
        ],
        certType: [
          {
            required: true,
            message: "请选择证件信息",
            trigger: "blur",
          },
        ],
        companyLogo: [
          {
            required: true,
            message:
              this.perfectData.purType == 0
                ? "请上传机关logo"
                : this.perfectData.purType == 1
                ? "请上传单位logo"
                : this.perfectData.purType == 2
                ? "请上传团体logo"
                : "请上传公司logo",
            trigger: "blur",
          },
        ],
        busLicenseImg: [
          {
            required: true,
            message: "请上传营业执照",
            trigger: "blur",
          },
        ],

        orgNoImg: [
          {
            required: true,
            message: "请上传组织机构代码",
            trigger: "blur",
          },
        ],
        orgNoCardImg: [
          {
            required: true,
            message: "请上传组织机构代码证",
            trigger: "blur",
          },
        ],
        bankAccountPermit: [
          {
            required: true,
            message: "请上传银行开户许可证",
            trigger: "blur",
          },
        ],
        creditCodeImg: [
          {
            required: true,
            message: "请上传统一信用代码证复印件",
            trigger: "blur",
          },
        ],
        legalCertImg: [
          {
            required: true,
            message: "请上传法人证书复印件",
            trigger: "blur",
          },
        ],
        legalIdFront: [
          {
            required: true,
            message: "请上传法人身份证复印件（正面）",
            trigger: "blur",
          },
        ],
        legalIdBack: [
          {
            required: true,
            message: "请上传法人身份证复印件（反面）",
            trigger: "blur",
          },
        ],
        contactIdFront: [
          {
            required: true,
            message: "请上传联系人身份证复印件（正面）",
            trigger: "blur",
          },
        ],
        contactIdBack: [
          {
            required: true,
            message: "请上传联系人身份证复印件（反面）",
            trigger: "blur",
          },
        ],
      };
    },
  },
  components: {
    vHead,
  },
  mounted() {
    if (this.$cookies.get("peopleId")) {
      this.navIndex = 1;
      this.perfectData.telephone = this.$cookies.get("userInfo").phone;
    }
  },
  methods: {
    changeNav(index) {
      // this.navIndex = index;
    },
    /**
     * 处理复选框
     */
    changeCheckbox() {
      this.isChecked = !this.isChecked;
    },

    /**
     * 发送验证码
     */
    sendCode() {
      var that = this;
      if (this.phone) {
        if (this.disable) return; // 改动的是这两行代码
        var myreg =
          /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
        if (!myreg.test(that.phone)) {
          that.$message({
            message: "请输入正确的手机号",
            type: "warning",
          });
          return;
        }
        this.disable = true;
        this.content = this.totalTime + "s后重新发送";
        const clock = window.setInterval(() => {
          this.totalTime--;
          this.content = this.totalTime + "s后重新发送";
          if (this.totalTime < 0) {
            window.clearInterval(clock);
            this.content = "发送验证码";
            this.totalTime = 60;
            this.disable = false; // 这里重新开启
          }
        }, 1000);
        doGet(
          httpConfig.Login.getCodeUrl,
          { phone: this.phone },
          function (res) {
            if (res.flag) {
              that.$message({
                message: res.message || "发送成功",
                type: res.message ? "warning" : "success",
              });
            } else {
              that.$message({
                message: res.message,
                type: "warning",
              });
            }
          },
          function (res) {}
        );
      } else {
        this.$message({
          message: "请先输入手机号",
          type: "warning",
        });
      }
    },
    /**
     * 确认注册
     */
    handleRegister() {
      var that = this;
      if (that.isChecked) {
        if (that.userName) {
          if (that.name) {
            if (that.phone) {
              if (that.verificationCode) {
                if (that.password) {
                  var reg = new RegExp(/^(?![^a-zA-Z]+$)(?!\D+$)/);
                  if (
                    that.password.length >= 8 &&
                    that.password.length <= 30 &&
                    reg.test(that.password)
                  ) {
                    if (that.checkPassword == that.password) {
                      postAction(
                        httpConfig.Register.register,
                        {
                          pcAccount: that.userName,
                          name: that.name,
                          phone: that.phone,
                          verificationCode: that.verificationCode,
                          pcPassword: that.password,
                          pcPassword2: that.checkPassword,
                        },
                        function (res) {
                          if (res.flag) {
                            res.data;
                            that.$cookies.set(
                              "userInfo",
                              JSON.stringify(res.data)
                            );
                            // sessionStorage.setItem("userInfo", JSON.stringify(res.data));
                            if (
                              that.$cookies.get("peopleIdCheck") != res.data.id
                            ) {
                              // that.$cookies.remove("shopCar");
                              // that.$cookies.remove("shopAddress");
                              // that.$cookies.remove("collectList");
                              that.$cookies.remove("peopleIdCheck");
                            }
                            that.$cookies.set("peopleId", res.data.id);
                            that.$cookies.set("peopleIdCheck", res.data.id);
                            // localStorage.setItem("xfh_usertoken", res.data.token);
                            that.registerSuccess = true;
                            // that.$router.push("/login");
                          } else {
                            that.$message({
                              message: res.message,
                              type: "warning",
                            });
                          }
                        },
                        function (res) {}
                      );
                    } else {
                      that.$message({
                        message: "两次密码不一致",
                        type: "warning",
                      });
                    }
                  } else {
                    that.$message({
                      message: "密码格式不正确",
                      type: "warning",
                    });
                  }
                } else {
                  that.$message({
                    message: "请输入密码",
                    type: "warning",
                  });
                }
              } else {
                that.$message({
                  message: "请输入验证码",
                  type: "warning",
                });
              }
            } else {
              that.$message({
                message: "请输入手机号",
                type: "warning",
              });
            }
          } else {
            that.$message({
              message: "请输入单位名称",
              type: "warning",
            });
          }
        } else {
          that.$message({
            message: "请输入账号",
            type: "warning",
          });
        }
      } else {
        that.$message({
          message: "请先阅读并同意注册协议",
          type: "warning",
        });
      }
    },
    /**
     * 提交
     */
    submit(form) {
      var that = this;
      this.$refs[form].validate((valid) => {
        if (valid) {
          var params = JSON.parse(JSON.stringify(that.perfectData));
          params.companyAddrCode =
            Object.keys(params.companyAddr[0])[0] +
            "," +
            Object.keys(params.companyAddr[1])[0] +
            "," +
            Object.keys(params.companyAddr[2])[0] +
            "," +
            Object.keys(params.companyAddr[3])[0];
          params.companyAddr =
            Object.values(params.companyAddr[0])[0] +
            Object.values(params.companyAddr[1])[0] +
            Object.values(params.companyAddr[2])[0] +
            Object.values(params.companyAddr[3])[0];
          params.peopleId = JSON.parse(that.$cookies.get("peopleId"));
          doGet(
            httpConfig.Register.companyRegister,
            params,
            function (res) {
              if (res.flag) {
                that.navIndex = 2;
                const clock = window.setInterval(() => {
                  that.countdown--;
                  if (that.countdown <= 0) {
                    window.clearInterval(clock);
                    that.totalTime = 60;
                    that.$router.push("/personal");
                  }
                }, 1000);
              } else {
                that.isWrong = true;
              }
            },
            function (res) {}
          );
        } else {
          return false;
        }
      });
    },
    handleChange(file, fileList, item) {
      if (file.status == "ready") {
        this.perfectData[item] = file.url;
      } else if (file.status == "error") {
        this.perfectData[item] = undefined;
      }
    },
    /**
     * 上传文件前检查文件大小
     */
    beforeUpload(file) {
      const isJPG =
        file.type === "image/jpg" ||
        file.type === "image/jpeg" ||
        file.type === "image/png";
      const isLt500k = file.size / 1024 < 500;

      if (!isJPG) {
        this.$message.error("只能上传jpg/jpeg/png格式文件!");
      }
      if (!isLt500k) {
        this.$message.error("文件大小不能超过500kb!");
      }
      return isJPG && isLt500k;
    },
    /**
     * 上传成功
     */
    handleSuccess(response, file, fileList, item) {
      this.perfectData[item] = response.data;
    },
    /**
     * 删除图片
     */
    handleRemove(file, fileList, item) {
      this.perfectData[item] = "";
    },
    /**
     * 查看大图
     */
    handlePreview(file, fileList, item) {
      this.visible[item] = true;
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/register";
</style>



// WEBPACK FOOTER //
// src/components/page/register.vue